import { MAIN_MENU_TRANSLATION_KEY } from "../constants.js";
const localeEs = {
    [MAIN_MENU_TRANSLATION_KEY]: {
        SEE_ALL: 'Ver todo',
        LEFT_MENU_TITLE: 'Menú',
        OPEN_MENU: 'Abrir menú',
        CATALOG_MENU_LABEL: 'Cursos',
        RESOURCES_MENU_LABEL: 'Recursos',
        DEGREES_MENU_LABEL: 'Diplomados',
        PREMIUM_LANDING_LINK_LABEL: 'Para Personas',
        B2B_PLANS_LANDING_LINK_LABEL: 'Para Empresas',
        HIGHER_EDUCATION_LABEL: 'Higher Education',
        B2B_LANDING_LINK_LABEL: 'Para Empresas',
        HELP_CENTER_LABEL: 'Centro de Ayuda',
        CATALOG_MENU_TITLE: 'Explora Crehana',
        CATALOG_CATEGORIES_TITLE: 'Categorías',
        CATALOG_SUBCATEGORIES_TITLE: 'Subcategorías',
        CATALOG_SOFTWARE_TITLE: 'Software',
        COURSE_COUNT: '{{count}} curso',
        COURSE_COUNT_plural: '{{count}} cursos',
        NEW_COURSES_TITLE: 'Nuevos lanzamientos',
        NEW_COURSES_POPPER_TITLE: 'Nuevos lanzamientos en Crehana',
        NEW_COURSES_SEE_ALL: 'Ver todos los cursos nuevos',
        MICRODEGREES_POPPER_TITLE: 'Programas digitales con Universidades',
        FULL_MICRODEGREE_TITLE: 'MicroDegree en {{title}}',
        FULL_BOOTCAMP_TITLE: 'Bootcamp de {{title}}',
        MONTH_COUNT: '{{count}} mes',
        MONTH_COUNT_plural: '{{count}} meses',
        MICRODEGREE_PARTNER_LABEL: 'Cocreado y certificado por {{partner}}',
        MICRODEGREE_SEE_DETAILS: 'Ver detalles del programa',
        ACADEMY_TITLE: 'Academias',
        ACADEMY_POPPER_TITLE: 'Conoce nuestras academias',
        FULL_ACADEMY_TITLE: '{{title}}',
        ACADEMY_COUNT: '{{count}} ruta',
        ACADEMY_COUNT_plural: '{{count}} rutas',
        ACADEMIES_COUNT: '{{count}} Academia',
        ACADEMIES_COUNT_plural: '{{count}} Academias',
        ACADEMY_LEARNING_PATHS_COUNT: '{{count}} ruta de aprendizaje',
        ACADEMY_LEARNING_PATHS_COUNT_plural: '{{count}} rutas de aprendizaje',
        ACADEMY_TAG: 'Nuevo',
        MENTOR_LANDING_LABEL: 'Mentorías',
        BLOG_LABEL: 'Blog',
        RESOURCES_TOOLS_LABEL: 'Herramientas',
        COURSE_AGENDA_LABEL: 'Agenda de cursos',
        CREHANA_LIVE_LABEL: 'Lives',
        SEARCH_TITLE: 'Búsqueda',
        SEARCH_INPUT_HINT: '¿Qué quieres aprender hoy?',
        SEARCH_CLEAR: 'Limpiar',
        USER_DASHBOARD_COURSES_LABEL: 'Mis cursos',
        USER_DASHBOARD_PRODUCTS_LABEL: 'Productos',
        USER_DASHBOARD_SAVED_COURSES_LABEL: 'Mis guardados',
        B2B_DASHBOARD_LIST: 'Mis perfiles',
        B2B_ADMIN_DASHBOARD_LABEL_SHORT: 'Administrador',
        B2B_ADMIN_DASHBOARD_LABEL: 'Panel de administración',
        B2B_LEADER_DASHBOARD_LABEL_SHORT: 'Líder',
        B2B_LEADER_DASHBOARD_LABEL: 'Panel de líder',
        INBOX_LABEL: 'Chatea con un mentor',
        INBOX_LABEL_FOR_MENTORS: 'Chat de mentoría',
        SHOPPING_CART_LABEL: 'Carrito de compras',
        NOTIFICATIONS_LABEL: 'Notificaciones',
        FEEDBACK_LABEL: 'Feedback',
        LOGIN_LABEL_SHORT: 'Entrar',
        LOGIN_LABEL: 'Iniciar sesión',
        REGISTER_LABEL: 'Registrarse',
        USER_MENU_TITLE: 'Mi cuenta',
        LOGOUT: 'Cerrar sesión',
        FAQS: 'FAQS',
        DASHBOARD_SEARCH_HINT: '¿Qué buscas en tu panel?',
        RENEWAL_ITEM_MESSAGE: '¡Tu membresía vencerá en {{remainingDays}} días!',
        RENEWAL_ITEM_CTA: 'Quiero renovar',
        SEARCH_LABEL: 'Buscar',
        MESSAGE_LABEL: 'Hablar',
        SWITCH_TO_OLD_HU_LABEL: 'Estás usando la nueva versión de Crehana',
        SWITCH_TO_OLD_HU_CTA: 'Volver a la versión antigua',
        DOWNLOADABLE_RESOURCES_LABEL: 'Descargables',
        BLOG_CATEGORIES_LINK_LABEL: 'Categorías',
        LEFT_MENU_FOLLOW_US: 'Síguenos en',
        SEARCH_PLACEHOLDER: 'Buscar artículo, ebook, video...',
        LEFT_MENU_CATEGORIES_VIEW_MORE: 'Ver más categorías',
        LEFT_MENU_CATEGORIES_VIEW_LESS: 'Ver menos',
        LEFT_MENU_SOLUTIONS: 'Soluciones',
        SOLUTIONS_MENU_LEARNING_MANAGEMENT: 'Gestión de aprendizaje',
        SOLUTIONS_MENU_E_LEARNING: 'E-Learning',
        SOLUTIONS_MENU_E_LEARNING_DESCRIPTION: 'Accede a +1000 cursos, academias y mentoría para tu equipo.',
        SOLUTIONS_MENU_ELEVATE_LMS: 'Elevate LMS',
        SOLUTIONS_MENU_ELEVATE_LMS_DESCRIPTION: 'Centraliza tu plan de formación, contenido y aplicaciones.',
        SOLUTIONS_MENU_SKILL_XP: 'Skill XP: Test de habilidades',
        SOLUTIONS_MENU_SKILL_XP_DESCRIPTION: 'Mide el nivel actual de habilidades de cada persona.',
        SOLUTIONS_MENU_TALENT_MANAGEMENT: 'Gestión de talento',
        SOLUTIONS_MENU_DEVELOPMENT: 'Desarrollo',
        SOLUTIONS_MENU_DEVELOPMENT_DESCRIPTION: 'Desarrolla habilidades',
        SOLUTIONS_MENU_WORK_ENVIRONMENT: 'Clima laboral',
        SOLUTIONS_MENU_WORK_ENVIRONMENT_DESCRIPTION: 'Mide el clima laboral de tu empresa',
        SOLUTIONS_MENU_PERFORMANCE: 'Desempeño',
        SOLUTIONS_MENU_PERFORMANCE_DESCRIPTION: 'Gestiona y mide los objetivos de tu equipo con el negocio.',
        SOLUTIONS_MENU_ENGAGEMENT: 'Engagement',
        SOLUTIONS_MENU_ENGAGEMENT_DESCRIPTION: 'Gestiona la satisfacción con encuestas NPS, feedback y más.',
        PRODUCTS_TITLE: 'Productos Crehana',
        PRODUCTS_RECOGNITION_TITLE: 'Reconocimientos',
        PRODUCTS_RECOGNITION_DESCRIPTION: 'Reconoce y promueve los logros con medallas',
        PRODUCTS_PERFORMANCE_TITLE: 'Desempeño',
        PRODUCTS_PERFORMANCE_DESCRIPTION: 'Gestión de objetivos y plan de desarrollo',
        PRODUCTS_ENVIRONMENT_TITLE: 'Clima',
        PRODUCTS_RENVIRONMENT_DESCRIPTION: 'Evaluaciones de clima laboral y encuestas',
        PRODUCTS_ELEARNING_TITLE: 'E-learning',
        PRODUCTS_ELEARNING_DESCRIPTION: 'Cursos y recursos para elevar tus habilidades',
        PRODUCTS_ANALYTICS_TITLE: 'Análitica',
        PRODUCTS_ANALYTICS_DESCRIPTION: 'Monitorea tus procesos y genera reportes',
        PRODUCTS_MANAGE_TITLE: 'Administrar',
        PRODUCTS_MANAGE_DESCRIPTION: 'Gestiona usuarios y la configuración de la compañía',
        PRODUCTS_TREND_FUTURE_TITLE: 'Future of People',
        PRODUCTS_TREND_FUTURE_DESCRIPTION: 'Artículos relevantes para el desarrollo profesional',
        PRODUCTS_TREND_AMAZING_TITLE: 'Amazing People',
        PRODUCTS_TREND_AMAZING_DESCRIPTION: 'Podcast con expertos en desarrollo de personas'
    }
};
export default localeEs;
